import { INLinkProps } from '@components/INLink/types'
import Route from '@routes/utils'

export function isCrossingBetweenRouters(
    currentRouterType: 'pages' | 'app',
    targetRoute: INLinkProps['route']
): boolean {
    if (!targetRoute || !(targetRoute instanceof Route)) {
        return false
    }

    const { appRouter } = targetRoute.definition

    if (currentRouterType === 'pages' && appRouter) {
        return true
    }

    if (currentRouterType === 'app' && !appRouter) {
        return true
    }

    return false
}
